export default __webpack_public_path__ + "FWI_eW_Trapo_mitCashback_ab04-2026_Seite_1.jpg";